import React, { FC } from "react";
import { OnClickSideEffects } from "../../types";
import useIsListOfTemplatesForModuleFetching from "../../useIsListOfTemplatesForModuleFetching";
import NavigationModuleDropdownVariant from "./NavigationModuleDropdownVariant";
import useTemplateDataFromIds from "./useTemplateDataFromIds";

const Container: FC<Props> = ({ moduleId, onClickSideEffects }) => {
  const templateData = useTemplateDataFromIds(moduleId);

  const isFetching = useIsListOfTemplatesForModuleFetching(moduleId);
  const isLoading = isFetching && templateData.length === 0;

  return (
    <NavigationModuleDropdownVariant
      isLoading={isLoading}
      loaderConfig={{ size: 30 }}
      templateData={templateData}
      onClickSideEffects={onClickSideEffects}
    />
  );
};

export type Props = {
  moduleId: number;
  onClickSideEffects?: OnClickSideEffects;
};

export default Container;
export type ContainerProps = Props;
